import React from "react";
import {
    Button,
    Cards,
    MainContainer,
    RecipeHeader,
    RecipeImage,
} from "./HomeStyles";
import { useNavigate } from "react-router-dom";

const MAX_HEADER_LENGTH = 25;

const RecipeCard = ({ recipes }) => {
    console.log(recipes);
    let navigate = useNavigate();
    return (
        <MainContainer>
            {recipes.map((recipe, index) => (
                <Cards key={recipe.recipe.uri || index}>
                    <RecipeHeader>
                        {recipe.recipe.label.length > MAX_HEADER_LENGTH
                            ? recipe.recipe.label.substring(
                                  0,
                                  MAX_HEADER_LENGTH
                              ) + "..."
                            : recipe.recipe.label}
                    </RecipeHeader>
                    <RecipeImage src={recipe.recipe.image} />
                    <Button
                        onClick={() => {
                            navigate("/details", { state: { recipe } });
                        }}
                    >
                        Details
                    </Button>
                </Cards>
            ))}
        </MainContainer>
    );
};

export default RecipeCard;
